import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- stores
import SessionStore from 'stores/SessionStore';

// -- actions
import RouteAction from 'actions/RouteAction';
import PaymentAction from 'actions/PaymentAction';

// -- stores
import { RestaurantStore, PaymentReceiptStore } from 'stores';

// -- constants
import RoutingEnum from 'constants/RoutingEnum';
import Events from 'constants/Events';

// -- entities
import Timelapse from 'PMT/entities/Timelapse';
import PayoutList from 'PMT/entities/PayoutList';
import PayinList from 'PMT/entities/PayinList';

// -- components
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';
import TimelapsePicker from 'components/timelapse/TimelapsePicker';
import PayinsView from './components/PayinsView';
import PayoutsView from './components/PayoutsView';
import { Tabs, Tab } from 'react-bootstrap';

export default class ReceiptPage extends AbstractComponent {

  constructor() {
    super();

    this.arianeIcon = 'fa-line-chart';
    this.arianeDetails = [
      {
        name: I18n.tr('menu.payment'),
        link: RoutingEnum.STAT_HOME
      },
      {
        name: I18n.tr('menu.payment.stat'),
        link: null
      }
    ];
  }

  state = {
    timelapse: SessionStore.getTimelapse(),
    payinList: PaymentReceiptStore.getPayinList(),
    payoutList: PaymentReceiptStore.getPayoutList(),
    restaurant: RestaurantStore.getRestaurant(),
  };

  componentDidMount() {
    if (!RestaurantStore.getRestaurant().haveFeaturePayment()
      && !RestaurantStore.getRestaurant().haveFeatureOrder()
    ) {
      RouteAction.redirectToFeatureNonActivated();
      return;
    }

    PaymentReceiptStore.addListener(this.onChange);

    this.loadPayins(this.state.timelapse);
    this.loadPayouts(this.state.timelapse);
  }

  componentWillUnmount() {
    PaymentReceiptStore.removeListener(this.onChange);
  }

  loadPayins(timelapse: Timelapse) {
    this.showLoading();
    PaymentAction.loadPayins(timelapse);
  }

  loadPayouts(timelapse: Timelapse) {
    this.showLoading();
    PaymentAction.loadPayouts(timelapse);
  }

  // -- actions

  onTabChange = (activeKey) => {
    if (!_.isUndefined(activeKey)) {
      SessionStore.saveReceiptPageTab(activeKey);
    }
  };

  onChange = () => {
    const payinList: PayinList = PaymentReceiptStore.getPayinList();
    const payoutList: PayoutList = PaymentReceiptStore.getPayoutList();

    if (!_.isNull(payinList)) {
      SessionStore.saveTimelapse(payinList.timelapse);
    } else if (!_.isNull(payoutList)) {
      SessionStore.saveTimelapse(payoutList.timelapse);
    }
    this.setState({
      payinList,
      payoutList,
      timelapse: SessionStore.getTimelapse(),
      loading: false,
      apiError: PaymentReceiptStore.getApiError(),
    });
  };

  onTimelapseChange = (timelapse: Timelapse) => {
    SessionStore.saveTimelapse(timelapse);

    this.setState({
      payinList: null,
      payoutList: null,
    });

    this.loadPayins(timelapse);
    this.loadPayouts(timelapse);
  };

  renderPayinsView() {
    if (_.isNull(this.state.payinList)) {
      return this.renderOnLoadingContent();
    }

    return (
      <PayinsView
        payinList={this.state.payinList}
        currencyCode={this.state.restaurant.currency}
      />
    );
  }

  renderPayoutsView() {
    if (_.isNull(this.state.payoutList)) {
      return this.renderOnLoadingContent();
    }

    return (
      <PayoutsView
        payoutList={this.state.payoutList}
        currencyCode={this.state.restaurant.currency}
      />
    );
  }

  render() {
    return (
      <div className="receipt_page">

        <Ariane icon={this.arianeIcon} details={this.arianeDetails} />

        {this.renderLoading()}

        <div className="row">
          <TimelapsePicker
            className="col-xs-12 col-md-6 float-right text-right"
            timelapse={this.state.timelapse}
            onTimelapseChange={this.onTimelapseChange}
            timelapseSelection={SessionStore.getTimelapseSelection()}
          />
        </div>

        { /* <!-- Nav tabs --> */ }
        <Tabs
          defaultActiveKey={SessionStore.getReceiptPageTab()}
          id="receipt_page__tabs"
          onSelect={this.onTabChange}
        >
          <Tab
            eventKey={1}
            title={I18n.tr('receipt.tabs.payins').toUpperCase()}
          >
            <div className="top-buffer-30">
              {this.renderPayinsView()}
            </div>
          </Tab>

          <Tab
            eventKey={2}
            title={I18n.tr('receipt.tabs.payouts').toUpperCase()}
          >
            <div className="top-buffer-30">
              {this.renderPayoutsView()}
            </div>
          </Tab>

        </Tabs>
      </div>
    );
  }

}
